import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=01a8e63c&scoped=true&"
import script from "./ProductCenter.vue?vue&type=script&lang=js&"
export * from "./ProductCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=01a8e63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8e63c",
  null
  
)

export default component.exports